import { render } from "./CertificatePreview.vue?vue&type=template&id=27d78764"
import script from "./CertificatePreview.vue?vue&type=script&lang=js"
export * from "./CertificatePreview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__